module.exports = __webpack_public_path__ + "static/media/shamar.7446e9e2.png";